import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "About Us", path: "/about" },
    { name: "Contact", path: "/contact" }
  ];

  const services = [
    "IT Consulting",
    "Cloud Solutions",
    "Procurement",
    "Networking",
    "Cybersecurity",
    "DevOps"
  ];

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-4">DevOpsMitra</h3>
            <p className="text-slate-300 text-sm">
              Your Trusted IT Mitra for Growing Businesses
            </p>
            <p className="text-slate-400 text-xs mt-2">
              Devopsmitra IT and Procurement Solutions LLP
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-300 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-slate-300 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li>salesops@devopsmitra.com</li>
              <li>+91 8296425797</li>
              <li>9th Main, 7th Sector, HSR Layout</li>
              <li>Bangalore, Karnataka – 560102</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {currentYear} DevOpsMitra. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
